import NotificationsList from "./NotificiationsList";
export default NotificationsList;
